import { Genre } from "src/app/inventory/genre/genre";
import { FrCriteria } from "../../../../util/search/criteria/fr-criteria";

export class GenreFrCriteria extends FrCriteria {
  private genresByThemaCode= new Map<string, Genre>();
  
  public addGenre(genre: Genre) {
    this.genresByThemaCode.set(genre.themaCode, genre);
  }

  protected displayValue(value: string): string {
    let genre = this.genresByThemaCode.get(value);
    if(genre == undefined) {
      throw new Error("no genre exists for thema code " + value);
    }

    return genre.nameFr;
  }
}